export const Posts = () => null;

export const PostTeaser = () => null;
